import React from 'react'
import { Route } from 'react-router-dom'
import Navigation from '../Site/Navigation/Navigation'
import Header from '../Site/Header/Header'
import Footer from '../Footer/Footer'
import NotificationBar from '../Mainpage/NotificationBar/NotificationBar'

const MainLayout = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={props => (
            <>
                <NotificationBar />
                <Header />
                <Navigation />
                <main><Component {...props} /></main>
                <Footer />
            </>
        )} />
    )
}

export default MainLayout
